import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, vShow as _vShow, normalizeStyle as _normalizeStyle, vModelText as _vModelText, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '../assets/images/selectArrow.gif'


const _hoisted_1 = { class: "checkboxArea" }
const _hoisted_2 = { class: "checkboxAreaCheck" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  class: "smallBtnBox textleft mgB15",
  style: {"border-top":"1px solid #000000","border-bottom":"1px solid #000000","text-align":"left"}
}
const _hoisted_5 = { class: "checkboxAreaCheck bold" }
const _hoisted_6 = { class: "textCenter" }
const _hoisted_7 = { class: "checkboxArea mgB15" }
const _hoisted_8 = { class: "checkboxAreaCheck" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "textCenter" }
const _hoisted_11 = { class: "checkboxArea" }
const _hoisted_12 = { class: "checkboxAreaCheck" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "textCenter" }
const _hoisted_15 = { class: "layerTitle" }
const _hoisted_16 = {
  class: "layerMain",
  style: {"width":"100%"}
}
const _hoisted_17 = { class: "textinputLine" }
const _hoisted_18 = { class: "right" }
const _hoisted_19 = { class: "textinputLine" }
const _hoisted_20 = { class: "secondBlcok right" }
const _hoisted_21 = { class: "textinputLine" }
const _hoisted_22 = { class: "right" }
const _hoisted_23 = {
  class: "",
  style: {"margin":"10px 0 0 10px"}
}
const _hoisted_24 = { class: "textinputLine" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "right poRel" }
const _hoisted_27 = ["onUpdate:modelValue", "onBlur", "onKeyup"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "right" }
const _hoisted_30 = {
  class: "",
  style: {"margin":"10px 0 0 10px"}
}
const _hoisted_31 = { class: "textinputLine" }
const _hoisted_32 = { class: "right" }
const _hoisted_33 = {
  key: 0,
  class: "textinputLine"
}
const _hoisted_34 = { class: "layer groupSelect" }
const _hoisted_35 = { class: "checkboxArea" }
const _hoisted_36 = { class: "checkboxAreaCheck" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "textCenter" }
const _hoisted_39 = { class: "staronoff" }
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  class: "textCenter left",
  style: {"width":"100%","height":"50px"}
}
const _hoisted_42 = { class: "targetCheck" }
const _hoisted_43 = {
  class: "left dblineArea",
  style: {"width":"100%"}
}
const _hoisted_44 = { class: "textinputLine" }
const _hoisted_45 = { class: "secondBlcok left" }
const _hoisted_46 = { class: "textinputLine underline" }
const _hoisted_47 = { class: "secondBlcok left" }
const _hoisted_48 = { class: "textinputLine" }
const _hoisted_49 = { class: "yearday secondBlcok left" }
const _hoisted_50 = { class: "textinputLine underline" }
const _hoisted_51 = { class: "secondBlcok left" }
const _hoisted_52 = { class: "textinputLine" }
const _hoisted_53 = { class: "secondBlcok left" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "textinputLine underline" }
const _hoisted_56 = { class: "secondBlcok left" }
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "textinputLine" }
const _hoisted_59 = { class: "secondBlcok left" }
const _hoisted_60 = { class: "grayBox" }
const _hoisted_61 = { class: "layerBtnArea" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      class: "layer groupSelect",
      style: _normalizeStyle([{top : $data.ui.phone_layer.top+'px', left : $data.ui.phone_layer.left+'px'}, {"width":"250px","z-index":"1500"}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.code_list.filter(x => x.CATE_KEY == 'RPRS_CD'), (c) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: c.CODE,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.ui.RPRS_CD) = $event))
              }, null, 8, _hoisted_3), [
                [_vModelRadio, $data.ui.RPRS_CD]
              ]),
              _createTextVNode(" " + _toDisplayString(c.CODE_NM), 1)
            ])
          ]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.ui.IS_RPRS) = $event)),
              "true-value": "1",
              "false-value": "0"
            }, null, 512), [
              [_vModelCheckbox, $data.ui.IS_RPRS]
            ]),
            _cache[43] || (_cache[43] = _createTextVNode(" 대표번호", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => {$data.ui.is_phone_view = false;})
        }, "취소"),
        _cache[44] || (_cache[44] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => {$options.phone_save();})
        }, "저장")
      ])
    ], 4), [
      [_vShow, $data.ui.is_phone_view]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "layer groupSelect",
      style: _normalizeStyle([{top:$data.ui.book_layer.top + 'px', left:$data.ui.book_layer.left + 'px'}, {"width":"250px","z-index":"1500"}])
    }, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.book_list, (r) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.ui.book_nos) = $event)),
                value: r.BOOK_NO
              }, null, 8, _hoisted_9), [
                [_vModelCheckbox, $data.ui.book_nos]
              ]),
              _createTextVNode(" " + _toDisplayString(r.TITLE), 1)
            ])
          ]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[5] || (_cache[5] = ($event: any) => {$data.ui.is_book_view = false;})
        }, "취소"),
        _cache[45] || (_cache[45] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[6] || (_cache[6] = ($event: any) => {$options.book_save();})
        }, "저장")
      ])
    ], 4), [
      [_vShow, $data.ui.is_book_view]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "layer groupSelect",
      style: _normalizeStyle([{top:$data.ui.group_layer.top + 'px', left:$data.ui.group_layer.left + 'px'}, {"width":"450px","z-index":"1500"}])
    }, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.group_list, (r) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.ui.group_nos) = $event)),
                value: r.GROUP_NO
              }, null, 8, _hoisted_13), [
                [_vModelCheckbox, $data.ui.group_nos]
              ]),
              _createTextVNode(" " + _toDisplayString(r.GROUP_NM), 1)
            ])
          ]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[8] || (_cache[8] = ($event: any) => {$data.ui.is_group_view = false;})
        }, "취소"),
        _cache[46] || (_cache[46] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[9] || (_cache[9] = ($event: any) => {$options.group_save();})
        }, "저장")
      ])
    ], 4), [
      [_vShow, $data.ui.is_group_view]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "layer continput",
      style: _normalizeStyle([{"font-size":"16px","width":"380px"}, {top:$data.view_top+'px', left:$data.view_left+'px'}])
    }, [
      _createElementVNode("div", _hoisted_15, "연락처 " + _toDisplayString($data.is_edit_mode ? "수정" : "등록"), 1),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_17, [
            _cache[47] || (_cache[47] = _createTextVNode(" 이름 ", -1)),
            _cache[48] || (_cache[48] = _createElementVNode("span", { class: "red" }, "*", -1)),
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.api.cust_info.CUST_NM) = $event)),
                ref: "CUST_NM",
                maxlength: "30"
              }, null, 512), [
                [_vModelText, $data.api.cust_info.CUST_NM]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[49] || (_cache[49] = _createTextVNode(" 성별 ", -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: _normalizeClass(["whiteBtn mgR05 left", {'select' : $data.api.cust_info.IS_SEX == 1}]),
                onClick: _cache[11] || (_cache[11] = ($event: any) => ($data.api.cust_info.IS_SEX = 1))
              }, "남", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["whiteBtn mgR05 left", {'select' : $data.api.cust_info.IS_SEX == 0}]),
                onClick: _cache[12] || (_cache[12] = ($event: any) => ($data.api.cust_info.IS_SEX = 0))
              }, "여", 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[51] || (_cache[51] = _createTextVNode(" 호칭 ", -1)),
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "어떻게 부르시나요? ex/선생님, 선배님, 사장님",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($data.api.cust_info.VOCA_NM) = $event)),
                ref: "VOCA_NM"
              }, null, 512), [
                [_vModelText, $data.api.cust_info.VOCA_NM]
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    onChange: _cache[14] || (_cache[14] = ($event: any) => {$options.setVOCA_NM();}),
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($data.ui.is_voca_nm) = $event)),
                    maxlength: "32"
                  }, null, 544), [
                    [_vModelCheckbox, $data.ui.is_voca_nm]
                  ]),
                  _cache[50] || (_cache[50] = _createTextVNode(" 이름+님 호칭 입력", -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[54] || (_cache[54] = _createElementVNode("div", { class: "mgB10" }, [
              _createTextVNode("전화번호"),
              _createElementVNode("span", { class: "red" }, "*")
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ui.phone_arr, (r, index) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                  class: "left telTitleArea poRel",
                  onClick: ($event: any) => {$options.phone_view(index, $event);}
                }, [
                  _createTextVNode(_toDisplayString(r.IS_RPRS == 1 ? '(대표)' : '') + " " + _toDisplayString($options.getCodeNm('RPRS_CD', r.RPRS_CD )) + " ", 1),
                  _cache[52] || (_cache[52] = _createElementVNode("img", { src: _imports_0 }, null, -1))
                ], 8, _hoisted_25),
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "widthcloseBtn",
                    "onUpdate:modelValue": ($event: any) => ((r.PHONE_CNO) = $event),
                    maxlength: "13",
                    onBlur: ($event: any) => ($options.autoPhone(r, $event)),
                    onKeyup: ($event: any) => ($options.autoPhone(r, $event))
                  }, null, 40, _hoisted_27), [
                    [
                      _vModelText,
                      r.PHONE_CNO,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  ($data.ui.phone_arr.length > 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "layerInputClose right",
                        onClick: ($event: any) => {$options.phone_remove(index);}
                      }, null, 8, _hoisted_28))
                    : _createCommentVNode("", true)
                ]),
                _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1))
              ]))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = ($event: any) => {$options.phone_arr_add();})
              }, "+ 추가전화번호 등록")
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[55] || (_cache[55] = _createTextVNode(" 그룹 ", -1)),
            _createElementVNode("button", {
              class: "greenBtn",
              onClick: _cache[17] || (_cache[17] = ($event: any) => {$options.group_view($event);})
            }, "그룹선택"),
            _createElementVNode("div", _hoisted_32, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                disabled: "",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($data.ui.group_nms) = $event))
              }, null, 512), [
                [_vModelText, $data.ui.group_nms]
              ])
            ])
          ]),
          (!$data.is_edit_mode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _cache[57] || (_cache[57] = _createTextVNode(" 메모 ", -1)),
                _createElementVNode("button", {
                  class: "mgL10",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => ($options.memo_tag_view()))
                }, "태그선택"),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ui.memo_tag_list, (r) => {
                  return (_openBlock(), _createElementBlock("span", null, _toDisplayString('#'+r.TAG_NM) + "  ", 1))
                }), 256)),
                _withDirectives(_createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tag_list, (r2) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: r2.TAG_NO,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($data.tag_nos) = $event))
                          }, null, 8, _hoisted_37), [
                            [_vModelCheckbox, $data.tag_nos]
                          ]),
                          _createTextVNode(" " + _toDisplayString(r2.TAG_NM), 1)
                        ])
                      ]))
                    }), 256))
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("button", {
                      class: "grayBtn",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => {$data.ui.memo_tag_layer=false;})
                    }, "취소"),
                    _cache[56] || (_cache[56] = _createTextVNode("  ", -1)),
                    _createElementVNode("button", {
                      class: "blueBtn",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => ($options.memo_tag_update()))
                    }, "저장")
                  ])
                ], 512), [
                  [_vShow, $data.ui.memo_tag_layer]
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("img", {
                    src: require(`@/assets/images/star_${$data.ui.IS_IMPO ? 'on' : 'off'}.png`),
                    title: "중요 메모 여부",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => ($options.memo_state_update('impo')))
                  }, null, 8, _hoisted_40)
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  style: {"width":"calc(100% - 10px)","height":"100px","margin":"10px 0 10px"},
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($data.api.cust_info.MEMO) = $event))
                }, null, 512), [
                  [_vModelText, $data.api.cust_info.MEMO]
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("label", _hoisted_42, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($data.api.cust_info.BLVR_TYPE_CD) = $event)),
              "true-value": "2",
              "false-value": "1"
            }, null, 512), [
              [_vModelCheckbox, $data.api.cust_info.BLVR_TYPE_CD]
            ]),
            _cache[58] || (_cache[58] = _createTextVNode(" 포교대상자", -1))
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_43, [
          _cache[68] || (_cache[68] = _createElementVNode("div", { class: "mgB10 bold" }, [
            _createTextVNode("대상자 구분"),
            _createElementVNode("span", { class: "red" }, "(필수)")
          ], -1)),
          _createElementVNode("div", _hoisted_44, [
            _cache[59] || (_cache[59] = _createElementVNode("div", { class: "firstBlock left" }, "상생방송", -1)),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", {
                class: _normalizeClass(["whiteBtn mgR05 left", {'select' : $data.api.cust_info.BLVR_CATE_CD == '1'}]),
                onClick: _cache[26] || (_cache[26] = ($event: any) => ($data.api.cust_info.BLVR_CATE_CD='1'))
              }, "적극시청", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["whiteBtn mgR05 left", {'select' : $data.api.cust_info.BLVR_CATE_CD == '2'}]),
                onClick: _cache[27] || (_cache[27] = ($event: any) => ($data.api.cust_info.BLVR_CATE_CD='2'))
              }, "가끔시청", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["whiteBtn left", {'select' : $data.api.cust_info.BLVR_CATE_CD == '3'}]),
                onClick: _cache[28] || (_cache[28] = ($event: any) => ($data.api.cust_info.BLVR_CATE_CD='3'))
              }, "시청안함", 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _cache[60] || (_cache[60] = _createElementVNode("div", { class: "firstBlock left" }, "역사광복", -1)),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", {
                class: _normalizeClass(["whiteBtn mgR05 left", {'select' : $data.api.cust_info.BLVR_CATE_CD == '4'}]),
                onClick: _cache[29] || (_cache[29] = ($event: any) => ($data.api.cust_info.BLVR_CATE_CD = '4'))
              }, "역사", 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _cache[63] || (_cache[63] = _createElementVNode("div", { class: "firstBlock left" }, "나이", -1)),
            _createElementVNode("div", _hoisted_49, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                style: {"width":"50px"},
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($data.api.cust_info.BIRT_YE) = $event)),
                onChange: _cache[31] || (_cache[31] = ($event: any) => {$options.cust_age('YEAR');})
              }, null, 544), [
                [_vModelText, $data.api.cust_info.BIRT_YE]
              ]),
              _cache[61] || (_cache[61] = _createTextVNode("년생 ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                style: {"width":"50px"},
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($data.api.cust_info.CUST_AGE) = $event)),
                onChange: _cache[33] || (_cache[33] = ($event: any) => {$options.cust_age('AGE');})
              }, null, 544), [
                [_vModelText, $data.api.cust_info.CUST_AGE]
              ]),
              _cache[62] || (_cache[62] = _createTextVNode("세 ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _cache[64] || (_cache[64] = _createElementVNode("div", { class: "firstBlock left" }, "등급", -1)),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", {
                class: _normalizeClass(["whiteBtn mgR05 left", {'select' : $data.api.cust_info.RTNG_CD == 'A'}]),
                onClick: _cache[34] || (_cache[34] = ($event: any) => ($data.api.cust_info.RTNG_CD = 'A'))
              }, "A", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["whiteBtn mgR05 left", {'select' : $data.api.cust_info.RTNG_CD == 'B'}]),
                onClick: _cache[35] || (_cache[35] = ($event: any) => ($data.api.cust_info.RTNG_CD = 'B'))
              }, "B", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["whiteBtn mgR05 left", {'select' : $data.api.cust_info.RTNG_CD == 'C'}]),
                onClick: _cache[36] || (_cache[36] = ($event: any) => ($data.api.cust_info.RTNG_CD = 'C'))
              }, "C", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["whiteBtn mgR05 left", {'select' : $data.api.cust_info.RTNG_CD == 'D'}]),
                onClick: _cache[37] || (_cache[37] = ($event: any) => ($data.api.cust_info.RTNG_CD = 'D'))
              }, "D", 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _cache[65] || (_cache[65] = _createElementVNode("div", { class: "firstBlock left" }, "유형", -1)),
            _createElementVNode("div", _hoisted_53, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.code_list.filter(x => x.CATE_KEY == 'BLVR_RELA_CD'), (c) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["whiteBtn mgR05 left", {'select' : $data.api.cust_info.BLVR_RELA_CD == c.CODE}]),
                  onClick: ($event: any) => ($data.api.cust_info.BLVR_RELA_CD = c.CODE)
                }, _toDisplayString(c.CODE_NM), 11, _hoisted_54))
              }), 256))
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _cache[66] || (_cache[66] = _createElementVNode("div", { class: "firstBlock left" }, "지역", -1)),
            _createElementVNode("div", _hoisted_56, [
              _withDirectives(_createElementVNode("select", {
                class: "selectBox",
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($data.api.cust_info.REGI_CD) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.code_list.filter(x => x.CATE_KEY == 'REGI_CD'), (c) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: c.CODE
                  }, _toDisplayString(c.CODE_NM), 9, _hoisted_57))
                }), 256))
              ], 512), [
                [_vModelSelect, $data.api.cust_info.REGI_CD]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _cache[67] || (_cache[67] = _createElementVNode("div", { class: "firstBlock left" }, [
              _createTextVNode("진리서적"),
              _createElementVNode("br"),
              _createTextVNode("홍보")
            ], -1)),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("button", {
                onClick: _cache[39] || (_cache[39] = ($event: any) => {$options.book_view($event);})
              }, "도서선택"),
              _createElementVNode("div", _hoisted_60, _toDisplayString($data.ui.book_nms), 1)
            ])
          ])
        ], 512), [
          [_vShow, $data.api.cust_info.BLVR_TYPE_CD =='2']
        ])
      ]),
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[40] || (_cache[40] = ($event: any) => {$options.cust_layer_close();})
        }, "취소"),
        _cache[69] || (_cache[69] = _createTextVNode("  ", -1)),
        (!$data.is_edit_mode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "yellowBtn",
              onClick: _cache[41] || (_cache[41] = ($event: any) => {$options.cust_save_init();})
            }, "저장 후 추가등록"))
          : _createCommentVNode("", true),
        _cache[70] || (_cache[70] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[42] || (_cache[42] = ($event: any) => {$options.cust_save('ONE');})
        }, "저장")
      ])
    ], 4), [
      [_vShow, $data.is_view]
    ])
  ], 64))
}